import React, { useEffect, useState } from 'react';
import { TimerIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const blocks = [{
    value: pad(hours),
    label: 'HRS'
  }, {
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEC'
  }];
  return <div className="mx-auto w-full max-w-sm rounded-2xl border border-alert-500/40 bg-alert-500/10 px-4 py-4" data-id="element-20" data-mp="15g0n7qgtdxt3">
      <p className="flex items-center justify-center gap-2 text-[0.7rem] font-bold uppercase tracking-[0.16em] text-alert-500" data-id="element-21" data-mp="2zrno9uqauuhx">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-22" data-mp="1c0f59a3ke8sy" />
        This price expires in
      </p>
      <div className="mt-3 flex items-center justify-center gap-2" role="timer" aria-live="off" data-id="element-23" data-mp="1h01j9lr7vt2t">
        {blocks.map((block, index) => <React.Fragment key={block.label} data-id="element-24" data-mp="171c2jwb24eo5" data-mpi={index}>
            <div className="min-w-[68px] rounded-xl bg-navy-950 px-2 py-2 text-center" data-id="element-25" data-mp="172dh4ara7jam">
              <div className="font-display text-3xl font-extrabold tabular-nums text-white" data-id="element-26" data-mp="1us7ssozv71ta">
                {block.value}
              </div>
              <div className="text-[0.6rem] font-bold uppercase tracking-[0.18em] text-slate-500" data-id="element-27" data-mp="1zs3v8jswyl6q">
                {block.label}
              </div>
            </div>
            {index < blocks.length - 1 ? <span className="font-display text-2xl font-extrabold text-alert-500/70" data-id="element-28" data-mp="2dq0uxp2nz7pm">
                :
              </span> : null}
          </React.Fragment>)}
      </div>
    </div>;
}